import { type CSSProperties } from 'react'

export const checkboxLabelStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  cursor: 'pointer',
  fontSize: '0.9em',
}

export const DIST_COLORS = {
  revenue: '#3b82f6',
  expenses: '#f97316',
  bills: '#22c55e',
}

export const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })
